import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import OfferTime from "./OfferTime";
import EventName from "./EventName";
import BettingType from "./BettingType";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function OfferItem(props: {
	offer: BetOffer;
	groupHasTitle: boolean;
	offersHaveColor: boolean;
	isPopup?: boolean;
}) {
	const { isSystem: isBetSystem, totalNumberOfCombinations } =
		useContext(MyBetsBetContext);

	const colorClass = props.offersHaveColor
		? `u-color--offer--${props.offer.formattedBettingOfferStatus}`
		: "";

	const isSystem = isBetSystem == null;

	const systemIdStr =
		isSystem == true && totalNumberOfCombinations > 1
			? props.offer.systemIdentifier
			: "";

	return (
		<>
			<OfferTime
				offer={props.offer}
				groupHasTitle={props.groupHasTitle}
			/>
			<div className="bet__pick">
				<div className="bet__combi">{systemIdStr}</div>

				<div className={"bet__pick__inner"}>
					<div className="bet__pick__row">
						<div
							className={`bet__status ${props.offer.formattedBettingOfferStatus}`}
						>
							<div
								className={`bet__status__indicator ${props.offer.formattedBettingOfferStatus}`}
							></div>
						</div>
						{props.offer.isBank === true && (
							<div className="bet__bank tag tag--tny tag--success">
								B
							</div>
						)}
						<div className="bet__type">
							{!props.groupHasTitle && (
								<EventName offer={props.offer} />
							)}{" "}
							<BettingType
								offer={props.offer}
								colorClass={colorClass}
								isPopup={props.isPopup}
							/>
						</div>
						<div
							className={"bet__quote u-display--b " + colorClass}
						>
							{props.offer.value.toFixed(2)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
});
